<template>
  <span class="caret-wrapper">
    <i
      class="sort-caret ascending"
      :class="[this.sort == this.field && this.order == 'desc' ? 'active' : '']"
    ></i>
    <i
      class="sort-caret descending"
      :class="[this.sort == this.field && this.order == 'asc' ? 'active' : '']"
    ></i>
  </span>
</template>
<script>
  export default {
    name: 'sort-caret',
    props: ["order", "sort", "field"]
  }
</script>



// WEBPACK FOOTER //
// src/views/doc-out/SortCaret.vue